import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NewChat = () => {
  const navigate = useNavigate();
  
  const clickHandler = () => {
    navigate('/chat/new');
    if(document.querySelector('.landing-container')) document.querySelector('.landing-container').scrollTop = 0;
  };

  return (
    <div
      onClick={clickHandler}
      className="new-chat-btn mb-4 flex flex-shrink-0 cursor-pointer text-left gap-1 rounded-md px-2 py-2 pr-5 text-sm transition-colors duration-200"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          clickHandler();
        }
      }}
      aria-label="New chat"
    >
      + New Chat
    </div>
  );
};

export default NewChat;
